module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTDvM4TvM4TvM4TvM4TvM4TvM4TvM4TvM4TvM4TvM4VXVmp4AAAAKdFJOUwDMbRI+8ZcshuboqNGQAAAACXBIWXMAAABIAAAASABGyWs+AAAAnElEQVQY01WQIQ/CQAyFHxvhLAYzNT11AvwS1HAENzU9dZrfgcJt4Ubor1x7NIV7ql/z2vQVKA6UdK2BsiLV5LEh0x7ND2aIazkfR/GhJ/oEwD2JIrjzBuvOhcAAF7BTaDEu2CrAEQUoeO62pdmqyWwDitoW3GT1SWEWaBSi5+N7BR5KI194AReDGJy4YopAjy5FzcNlsbOH/L9qBQAnidhpMh36AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/school/position.png
// module id = 849
// module chunks = 0